<script>
const base = process.env.VUE_APP_API_BASE_URL

export default {
  base
}

</script>
